import React, { useContext, useRef, useState } from 'react'
import { Button, ListMenu, ListMenuButton, Modal, NotificationManagerContext,
   Popover, View } from 'oio-react'
import PropTypes from 'prop-types'
import { MoreIcon } from 'assets/icons'
import { useUpdateNote, useRemoveNote } from 'src/graphql/hooks'
import NoteMove from '~/apps/NoteMove'

const NoteMoreControl = ({ noteId, pinned }) => {
   const popoverButton = useRef()
   const [popoverIsOpen, setPopoverIsOpen] = useState(false)
   const [modalIsOpen, setModalIsOpen] = useState(false)
   const { showNotification } = useContext(NotificationManagerContext)

   const { removeNote } = useRemoveNote()
   const { updateNote } = useUpdateNote()

   const handleRemoveNote = async () => {
      try {
         await removeNote({ id: noteId })
         showNotification({
            message: 'Note deleted successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         window.alert(err.message)
      }
   }

   const handleTogglePinned = async () => {
      try {
         await updateNote({ id: noteId }, { pinned: !pinned })
      } catch (err) {
         window.alert(err.message)
      }
   }

   return (
      <View position="relative">
         <Button
            ref={popoverButton}
            onClick={() => setPopoverIsOpen(true)}
            color="#eee"
            width="30px"
            size="xs[a-b] sm[c-f]"
            rounded>
            <MoreIcon width="18px" height="18px" />
         </Button>
         <Popover
            anchorElement={popoverButton.current}
            anchorOriginHorizontal="right"
            anchorOriginVertical="top"
            borderRadius="6px"
            width="150px"
            onBodyClick={() => setPopoverIsOpen(false)}
            open={popoverIsOpen}>
            <View
               float="left"
               width="100%"
               borderRadius="6px"
               backgroundColor="#fff"
               boxShadow="6px 6px 30px rgba(0,0,0,0.1)">
               <ListMenu buttonSize="md">
                  <ListMenuButton
                     onClick={handleTogglePinned}
                     name={pinned ? 'Unpin Note' : 'Pin Note'}
                  />
                  <ListMenuButton
                     onClick={() => setModalIsOpen(true)}
                     name="Move Note"
                  />
                  <ListMenuButton
                     onClick={handleRemoveNote}
                     name="Delete Note"
                  />
               </ListMenu>
            </View>
         </Popover>
         <Modal
            borderRadius="3px"
            width="300px"
            open={modalIsOpen}>
            <NoteMove
               onCancelButtonClick={() => setModalIsOpen(false)}
               onNoteMove={() => setModalIsOpen(false)}
               noteId={noteId}
            />
         </Modal>
      </View>
   )
}

NoteMoreControl.propTypes = {
   noteId: PropTypes.string.isRequired,
   pinned: PropTypes.bool.isRequired
}

export default NoteMoreControl
